import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, InlineRangeAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectHouseYearFilter } from 'shared/selectors/advancedFilters';

export const HouseYearContainer: FC = () => {
  const {
    value: { min: valueMin, max: valueMax },
    min,
    max,
  } = useSelector(selectHouseYearFilter);

  const onChange = useFilterChangeCallback();

  const handleMinChange = useCallback(
    (newMin: number | null) => {
      onChange({ action: 'setHouseYear', arguments: [newMin, valueMax] });
    },
    [onChange, valueMax],
  );

  const handleMaxChange = useCallback(
    (newMax: number | null) => {
      onChange({ action: 'setHouseYear', arguments: [valueMin, newMax] });
    },
    [onChange, valueMin],
  );

  return (
    <AdvancedFilterRow label="Год постройки">
      <InlineRangeAdvancedFilter
        min={min}
        max={max}
        valueMin={valueMin}
        valueMax={valueMax}
        thousandsSeparator=""
        onMinChange={handleMinChange}
        onMaxChange={handleMaxChange}
      />
    </AdvancedFilterRow>
  );
};
